
export class CustomerGroup {
  public bGrpUserActive: boolean;
  public objCustomizableCriteriaList: any;
  public objCustomizableDataList: any;
  public objCustomizableDisplayList: any;
  public sCustomerID: string;
  public sAnalytiqueID: string;
  public sTrtChainName: string;
  public sGrpUserID: string;
  public sGrpUserLabel: string;
  public sLangId: string;
  public sAlarmeEmail: string;
  public sCustomerGrpEmail: string;
  public sLevelIdParent: string;
  public pathParent: string;

  public objOrgUserList?: {
    datas: Array<{ sUserID: string }>
  };

  public filterContent?: string;

  constructor() {
  }
}
